import { useBrowsePresetApi } from '@aibees/shared/api';
import { Nullable, PresetVisibility } from '@aibees/shared/definition';
import { useQueryStringState } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { memo, useEffect } from 'react';
import { useSearchListCardStore } from '../../store';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { SavedCardTableProps as Props } from './types';

export const SavedCardTable = memo(({ className }: Props) => {
  const { grouping, name, visibility, setEmpty, setIsLoading } =
    useSearchListCardStore();
  const { params } = useQueryStringState();
  const sortValue =
    params.sortField && params.sortOrder
      ? `${params.sortField}:${params.sortOrder}`
      : 'favorite:desc,modified:desc';
  const browseApi = useBrowsePresetApi({
    type: grouping,
    size: 10,
    name,
    visibility: visibility as unknown as Nullable<PresetVisibility>,
    sort: sortValue,
  });

  useEffect(() => {
    setEmpty(browseApi.data?.empty);
    setIsLoading(browseApi.isLoading);
  }, [browseApi.data?.empty, browseApi.isLoading]);

  return (
    <Styled.Wrapper
      className={classnames('SavedCardTable', className)}
      sx={SX.root}
      config={{
        ...config,
        browseApi: {
          data: browseApi.data?.content.slice(0, 4),
          isLoading: browseApi.isLoading,
        },
      }}
    />
  );
});

SavedCardTable.displayName = 'SavedCardTable';
